/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Form, FormikProps } from 'formik';
import useTranslate from 'hooks/useTranslate';
import {
  useMarkdownTranslate,
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';
import PageContainer from 'components/PageContainer';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import Title from 'components/Title';
import Button from 'components/Button';
import { MobileField } from 'components/form';
import styles from './styles';
import BackToPrevious from 'components/unified/BackToPrevious';

export interface FormValues {
  mobilePhone: string | null;
}

type PropTypes<T extends FormValues> = FormikProps<T>;

export default function MobileVerificationView<T extends FormValues>(
  props: PropTypes<T>,
) {
  const { isValid, isSubmitting } = props;
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();

  return (
    <Form>
      <PageContainer maxWidth="sm">
        <div css={styles.headingContainer}>
          <Title>
            {tMd('unified.consumerSearch.mobileVerification.title')}
          </Title>
        </div>
        <div css={styles.subHeadingContainer}>
          {tMdMultiline('unified.consumerSearch.mobileVerification.subtitle')}
        </div>

        <MobileField
          showDisclosure={false}
          id="mobilePhone"
          label={t('formLabel.mobilePhone')}
        />

        <div css={styles.finePrint}>
          {tMdMultiline('unified.consumerSearch.mobileVerification.iPayPolicy')}
        </div>

        <ActionButtonContainer>
          <Button
            mobileFullWidth={true}
            type="submit"
            id="formSubmit"
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
          >
            {tMd('unified.consumerSearch.mobileVerification.submitButton')}
          </Button>

          <BackToPrevious tMdKey="unified.consumerSearch.mobileVerification.backButton" />
        </ActionButtonContainer>
      </PageContainer>
    </Form>
  );
}
